module.exports = __webpack_public_path__ + "img/AA5.png";